// extracted by mini-css-extract-plugin
module.exports = {"auth":"index_auth_3YQ97","container":"index_container_157Yc","googleSign":"index_googleSign_1ck1p","footerNav":"index_footerNav_2Sh3C"};